import { useTranslation } from 'react-i18next';

import { BuildingMesh } from 'app/modules/wallforming/components/scenes/objects/building/BuildingMesh';
import { useGetBuildingModel } from 'app/modules/wallforming/components/scenes/objects/building/hooks/useGetBuildingModel';
import { LoadingAnimation } from 'shared/components/LoadingAnimation';

export const Building = () => {
    const { t } = useTranslation();

    const { sessionguid, buildingModel, isGetFormingSessionByIdPending } = useGetBuildingModel();

    if (isGetFormingSessionByIdPending || !buildingModel) {
        return <LoadingAnimation text={t('labelLoadData')} />;
    }

    return <BuildingMesh key={sessionguid} buildingModel={buildingModel} />;
};
